import { combineReducers } from '@reduxjs/toolkit';
import clearingAccountReducer from './slices/AccountSetupSlice';
import bootstrapSlice from './slices/BootstrapSlice';
import EventSlice from './slices/EventSlice';
import installationSlice from './slices/InstallationSlice';
import organisationSlice from './slices/OrganisationSlice';
import settingsSlice from './slices/SettingsSlice';
import userSlice from './slices/UserSlice';
import connectionSlice from './slices/ConnectionSlice';
import beginFreeTrialSlice from './slices/BeginFreeTrialSlice';

const rootReducer = combineReducers({
    bootstrap: bootstrapSlice,
    installation: installationSlice,
    event: EventSlice,
    settings: settingsSlice,
    clearingAccount: clearingAccountReducer,
    organisation: organisationSlice,
    user: userSlice,
    connection: connectionSlice,
    freeTrial: beginFreeTrialSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
